import React, { useCallback } from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { CatalogItemKind } from 'fym-shared/src/smartlinks/catalog';
import { TypedMemo } from '../../../common/types';
import { Cover } from '../../../music24/components/primitives/Cover';
import { CatalogMergeOption } from '../../../../redux/api/fymAPI.types';
import { formatCatalogDay } from '../catalogDates';
import { mergeMessages } from './mergeMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the merge dialogs; each part uses its own slice of it */
import styles from './Merge.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface MergeOptionRowProps {
  option: CatalogMergeOption;
  isSelected: boolean;
  onSelect: (uuid: string) => void;
}

/** One song in the picker (design catalog-merge a2): a radio, the cover, the title and the facts. */
const MergeOptionRowComponent: React.FC<MergeOptionRowProps> = ({ option, isSelected, onSelect }) => {
  const intl = useIntl();
  const select = useCallback(() => onSelect(option.uuid), [onSelect, option.uuid]);
  const facts = [
    option.releaseType,
    option.releaseDate === null ? null : formatCatalogDay(intl, option.releaseDate),
    option.kind === CatalogItemKind.unreleased ? intl.formatMessage(mergeMessages.addedByYou) : null,
  ].filter((fact): fact is string => fact !== null && fact !== '');

  return (
    <button
      type="button"
      role="radio"
      aria-checked={isSelected}
      className={clsx(styles.option, isSelected && styles.optionOn)}
      onClick={select}
      data-testid="merge-option"
    >
      <input type="radio" checked={isSelected} readOnly tabIndex={-1} aria-hidden="true" />
      <Cover src={option.artworkUrl ?? undefined} label={option.title} size={40} />
      <span>
        <span className={styles.optionName}>{option.title}</span>
        <span className={styles.optionSub}>{facts.join(' · ')}</span>
      </span>
    </button>
  );
};

export const MergeOptionRow = TypedMemo(MergeOptionRowComponent);
